 export const errorsCount = (errors) => {
  if (!errors) { return 0; }

  return Object.keys(errors).reduce((total, key) => total + errors[key].length, 0);
};
